/**
 * Google Analytics 4. Se activa solo si hay un ID de medicion (G-XXXXXXXXXX), en este orden:
 *   1. window.FESTY_GA_ID, definido en /ga-config.js (se puede editar en el servidor sin recompilar)
 *   2. VUE_APP_GA_ID al compilar
 * Sin ID no se carga nada ni se envia ningun dato. window.festyTrack(nombre, parametros) envia eventos.
 */
export function initAnalytics (router) {
  const id = String(window.FESTY_GA_ID || process.env.VUE_APP_GA_ID || '').trim()
  window.festyTrack = () => {}
  if (!/^G-[A-Z0-9]+$/i.test(id)) return
  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  const s = document.createElement('script')
  s.async = true
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + id
  document.head.appendChild(s)
  window.gtag('js', new Date())
  window.gtag('config', id, { send_page_view: false, anonymize_ip: true })
  window.festyTrack = (name, params) => { window.gtag('event', name, Object.assign({ language: document.documentElement.lang }, params || {})) }
  if (router) {
    router.afterEach((to) => {
      // se espera un momento para que el titulo de la pagina ya este actualizado
      setTimeout(() => window.festyTrack('page_view', { page_title: document.title, page_location: window.location.href, page_path: to.fullPath }), 50)
    })
  }
}
